import React, { useState } from 'react';

import { ExpandableTextSection } from '@infinex-private/connect-web-shared/components';
import { cn } from '@infinex/ui-styles';
import { Button } from '@infinex/ui/components';

interface RawDataSectionProps {
  rawRequest: string;
}

export function RawDataSection({ rawRequest }: RawDataSectionProps) {
  const [showRawData, setShowRawData] = useState(false);

  return (
    <>
      {/* See Raw Data Button - only show if raw data not visible */}
      {!showRawData && (
        <div className="mt-3 flex justify-center">
          <Button onPress={() => setShowRawData(true)} className="w-full">
            See raw data
          </Button>
        </div>
      )}

      {/* Raw Data Section */}
      {showRawData && (
        <div className="bg-surface mt-3 overflow-hidden rounded-3xl px-5 py-6">
          <ExpandableTextSection
            title="Raw details"
            defaultExpanded={true}
            fadeGradientFrom="from-surface"
            lineThreshold={4}
          >
            <pre
              className={cn(
                'text-tertiary text-sm break-all whitespace-pre-wrap',
                // eslint-disable-next-line better-tailwindcss/no-unknown-classes
                'language-json'
              )}
            >
              {rawRequest}
            </pre>
          </ExpandableTextSection>
        </div>
      )}
    </>
  );
}
